import { render } from "./MyOrderDown.vue?vue&type=template&id=730fb538&scoped=true"
import script from "./MyOrderDown.vue?vue&type=script&lang=js"
export * from "./MyOrderDown.vue?vue&type=script&lang=js"

import "./MyOrderDown.vue?vue&type=style&index=0&id=730fb538&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-730fb538"]])

export default __exports__